import Vue from 'vue';
import { getPassportUrl } from '@/utils/other';
export default Vue.extend({
    props: {
        slotData: {
            required: true
        }
    },
    name: 'amountRangePopupChunk',
    computed: {
        getPassportLink() {
            return getPassportUrl('/id/', { withAcceptor: true });
        },
        nextVerificationLevel() {
            switch (this.slotData.verificationLevel) {
                case 'advanced':
                case 'extended':
                    return 'transfersPage.popups.amountRange.advancedLevel';
                default:
                    return 'transfersPage.popups.amountRange.extendedLevel';
            }
        },
        currentVerificationLevel() {
            switch (this.slotData.verificationLevel) {
                case 'advanced':
                    return 'transfersPage.popups.amountRange.advancedLevel';
                case 'extended':
                    return 'transfersPage.popups.amountRange.extendedLevel';
                default:
                    return 'transfersPage.popups.amountRange.baseLevel';
            }
        }
    }
});
